import React from 'react';
import { Field } from 'redux-form';
import { renderTextField, renderCheckbox } from '../../helpers/renderFormInputs';
import ModalInformation from '../../components/modals/ModalInformation';
import { getNote1_clinicalInformation } from '../../constants/modal_content/PART_1_CLINICAL_INFORMATION_SPECIMEN_RECEIPT';


export const clinicalInformationNoteJSX = () => (
  <div className="clinicalInformationNote">
    Clinical Information
      <i>(select all that apply)</i>
    <ModalInformation>{getNote1_clinicalInformation()}</ModalInformation>
  </div>
);

export const clinicalInformationIsNotProvidedJSX = (clinicalInformationIsNotProvided, handleNotProvided) => (
  <div className="clinicalInformationIsNotProvided">
    <Field
      name="clinicalInformationIsNotProvided"
      component={renderCheckbox}
      label="Not provided"
      checked={clinicalInformationIsNotProvided}
      onChange={handleNotProvided}
    />
  </div>
);

export const fieldsJSX = (clinicalInformationIsNotProvided, fields) => (
  fields.map(field => (
    <div key={field.name} className={`field-container ${field.name}`}>
      <div
        className={`label-container ${clinicalInformationIsNotProvided ? 'label-disabled' : ''}`}
      >
        <label>{field.label}</label>
      </div>
      <Field
        name={field.name}
        disabled={clinicalInformationIsNotProvided}
        component={renderTextField}
        multiLine={field.multiline}
        className="field"
        rows={field.multiline ? 4 : 1}
        rowsMax={4}
      />
    </div>
  )));

export const blockIdentificationKeyInfoJSX = () => (
  <div className="blockIdentificationKeyInfo">
    <label>BLOCK IDENTIFICATION KEY</label>
    <br />
    <i>

      (List overleaf or separately with an indication of the nature and origin of all tissue blocks)
      </i>
    <Field
      name="blockIdentificationKey"
      component={renderTextField}
      className="field"
    />
  </div>
);